/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { CarbonAccountingLedgers } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function CarbonAccountingLedgersUpdateForm(props) {
  const {
    id: idProp,
    carbonAccountingLedgers: carbonAccountingLedgersModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    CarbonAccountingLedgerName: "",
    Description: "",
  };
  const [CarbonAccountingLedgerName, setCarbonAccountingLedgerName] =
    React.useState(initialValues.CarbonAccountingLedgerName);
  const [Description, setDescription] = React.useState(
    initialValues.Description
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = carbonAccountingLedgersRecord
      ? { ...initialValues, ...carbonAccountingLedgersRecord }
      : initialValues;
    setCarbonAccountingLedgerName(cleanValues.CarbonAccountingLedgerName);
    setDescription(cleanValues.Description);
    setErrors({});
  };
  const [carbonAccountingLedgersRecord, setCarbonAccountingLedgersRecord] =
    React.useState(carbonAccountingLedgersModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(CarbonAccountingLedgers, idProp)
        : carbonAccountingLedgersModelProp;
      setCarbonAccountingLedgersRecord(record);
    };
    queryData();
  }, [idProp, carbonAccountingLedgersModelProp]);
  React.useEffect(resetStateValues, [carbonAccountingLedgersRecord]);
  const validations = {
    CarbonAccountingLedgerName: [],
    Description: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          CarbonAccountingLedgerName,
          Description,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            CarbonAccountingLedgers.copyOf(
              carbonAccountingLedgersRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "CarbonAccountingLedgersUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Carbon Accounting Ledger"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Text
        children="Update this carbon accounting ledger to record and link your Emissions, Reductions and Offsets."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Carbon accounting ledger name"
        isRequired={false}
        isReadOnly={false}
        value={CarbonAccountingLedgerName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              CarbonAccountingLedgerName: value,
              Description,
            };
            const result = onChange(modelFields);
            value = result?.CarbonAccountingLedgerName ?? value;
          }
          if (errors.CarbonAccountingLedgerName?.hasError) {
            runValidationTasks("CarbonAccountingLedgerName", value);
          }
          setCarbonAccountingLedgerName(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "CarbonAccountingLedgerName",
            CarbonAccountingLedgerName
          )
        }
        errorMessage={errors.CarbonAccountingLedgerName?.errorMessage}
        hasError={errors.CarbonAccountingLedgerName?.hasError}
        {...getOverrideProps(overrides, "CarbonAccountingLedgerName")}
      ></TextField>
      <TextAreaField
        label="Description"
        isRequired={false}
        isReadOnly={false}
        value={Description}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              CarbonAccountingLedgerName,
              Description: value,
            };
            const result = onChange(modelFields);
            value = result?.Description ?? value;
          }
          if (errors.Description?.hasError) {
            runValidationTasks("Description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("Description", Description)}
        errorMessage={errors.Description?.errorMessage}
        hasError={errors.Description?.hasError}
        {...getOverrideProps(overrides, "Description")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || carbonAccountingLedgersModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || carbonAccountingLedgersModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
